"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DropdownContext = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var DropdownContext = /*#__PURE__*/(0, _react.createContext)({
  negativeHover: false,
  onSelect: function onSelect() {},
  setOpen: function setOpen() {},
  visible: false,
  emptyHint: ''
});
exports.DropdownContext = DropdownContext;

var DropdownProvider = function DropdownProvider(_ref) {
  var children = _ref.children,
      negativeHover = _ref.negativeHover,
      onSelect = _ref.onSelect,
      setOpen = _ref.setOpen,
      visible = _ref.visible,
      emptyHint = _ref.emptyHint;
  return (0, _jsxRuntime.jsx)(DropdownContext.Provider, {
    value: {
      negativeHover: negativeHover,
      onSelect: onSelect,
      setOpen: setOpen,
      visible: visible,
      emptyHint: emptyHint
    },
    children: children
  });
};

DropdownProvider.propTypes = {
  children: _propTypes.node.isRequired,
  negativeHover: _propTypes.bool,
  onSelect: _propTypes.func,
  setOpen: _propTypes.func,
  visible: _propTypes.bool,
  emptyHint: _propTypes.string
};
DropdownProvider.defaultProps = {
  negativeHover: false,
  onSelect: function onSelect() {},
  setOpen: function setOpen() {},
  visible: false,
  emptyHint: 'No items'
};
var _default = DropdownProvider;
exports["default"] = _default;
//# sourceMappingURL=Dropdown.provider.js.map